












import Vue from "vue";
const config = require('../config/default.json');


export default Vue.extend({
  data() {
    return {
      serviceName: "Smart Me",
    };
  },
  methods: {
    setTitle () {
      if (config.toolEnv == "prod") {
            this.serviceName += '商用環境';
        } else {
            this.serviceName += '開発・ステージング環境';
        }
    }
  },
  mounted() {
      this.setTitle();
  }
});
